
<template>
    <div :class="{
        'navbar-item': true,
        'has-dropdown': ! isEmpty,
        'is-hoverable': ! isEmpty,
        'notifications': true,
    }">
        <button
            class="p-1 rounded-full hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
            :class="{
                'text-gray-400 bg-gray-800 focus:ring-offset-gray-800 ': isEmpty,
                'text-gray-400 bg-orange-500 focus:ring-offset-orange-500 ': !isEmpty,
            }"
        >
            <span class="sr-only">View notifications</span>
            <!-- Heroicon name: bell -->
            <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
        </button>

        <div v-if="! isEmpty" class="navbar-dropdown is-boxed is-right">
            <div class="navbar-item">
                <div class="content-holder">
                    <article
                        v-for="thread in threads"
                        :key="thread.id"
                        class="media unread"
                    >
                        <figure class="media-left">
                            <img :src="thread.user.extra_small_avatar">
                        </figure>
                        <div class="media-content">
                            <a class="content" :href="route('messages.show', {id: thread.id})" v-text="thread.subject"></a>
                            <small>
                                {{ moment(thread.created_at).fromNow() }}
                            </small>
                            <br />
                            <small><strong>From:</strong> {{ thread.user.name }}</small>
                        </div>
                    </article>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            threads: []
        };
    },

    computed: {
        actionRoute () {
            return this.route(
                'messages.index',
            );
        },

        threadsCount () {
            return _.size(this.threads);
        },

        isEmpty () {
            return _.isEmpty(this.threads);
        },
    },

    methods: {
        async fetchList () {
            try {
                this.loading = true;
                let {data} = await axios.get(this.actionRoute);

                this.threads = data.data;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },
    },

    created () {
        this.fetchList();
    },
};
</script>

<style>
a.isDisabled {
    color: currentColor;
    cursor: not-allowed;
    opacity: 0.5;
    text-decoration: none;
}
</style>
